import { cn } from '../lib/cn';

export type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse border-2 border-brut-border bg-brut-bg', className)}
      aria-hidden
    />
  );
}
